<script>

    import { toast } from 'bulma-toast'
    import { notificationStore, notificationsStore, modalStore, adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import NotificationsService from '../$services/notifications.service'
    import DateMethods from '../$methods/date.methods'

    import ButtonDelete from '../$components/button.delete.svelte'
    import ButtonModal from '../$components/button.modal.svelte'
    import InfoCard from '../$components/info.card.svelte'
    import InfoField from '../$components/info.field.svelte'

    let loading = false

    async function deleteNotification() {

        loading = true
        const resp = await NotificationsService.deleteNotification($notificationStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        notificationsStore.remove($notificationStore._id)

        toast({message: 'Notificación borrada', type: 'is-success'})

        modalStore.close()
    }

</script>

<InfoCard subtitle="Notificación">
    <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
        <InfoField label="Tema" icon="fas fa-tag" value={ $notificationStore.subject } bold />
        <InfoField label="¿Urgente?" icon="fas fa-exclamation-triangle" value={ $notificationStore.important ? 'Sí' : 'No' } />
        <InfoField label="Fecha de creación" icon="far fa-calendar-alt" value={ DateMethods.dateTimeLarge($notificationStore.created) } />
        <InfoField label="Fecha de expiración" icon="far fa-calendar-times" value={ DateMethods.dateTimeLarge($notificationStore.expired) } />
        <InfoField label="Mensaje" icon="fas fa-comment" value={ $notificationStore.message } size="full" />
    </div>
</InfoCard>

<div class="items-end">
    <div class="buttons">
        {#if isPermission($adminStore, 'UsersView.Notification.Delete')}
            <ButtonDelete on:confirm={deleteNotification} { loading } />
        {/if}
        {#if isPermission($adminStore, 'UsersView.Notification.Update')}
            <ButtonModal modalId="notification_update_modal" icon="edit" text="Actualizar" />
        {/if}
    </div>
</div>
